/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { EasyMath, EasyMathInterface } from "../EasyMath";

const _abi = [
  {
    inputs: [],
    name: "ZeroAssets",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroShares",
    type: "error",
  },
];

const _bytecode =
  "0x60566037600b82828239805160001a607314602a57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea26469706673582212203605d318ea2b41b5192b6deadc82978a9e86763b2555554d60c4f78d1236a1ed64736f6c634300080d0033";

type EasyMathConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: EasyMathConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class EasyMath__factory extends ContractFactory {
  constructor(...args: EasyMathConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "EasyMath";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<EasyMath> {
    return super.deploy(overrides || {}) as Promise<EasyMath>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): EasyMath {
    return super.attach(address) as EasyMath;
  }
  connect(signer: Signer): EasyMath__factory {
    return super.connect(signer) as EasyMath__factory;
  }
  static readonly contractName: "EasyMath";
  public readonly contractName: "EasyMath";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): EasyMathInterface {
    return new utils.Interface(_abi) as EasyMathInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): EasyMath {
    return new Contract(address, _abi, signerOrProvider) as EasyMath;
  }
}
